// extracted by mini-css-extract-plugin
module.exports = {"btn":"FavoriteBtn_btn__PdavJ","inWishlist":"FavoriteBtn_inWishlist__JI_tg"};